import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=5575aaf8&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./OrderDetails.vue?vue&type=style&index=0&id=5575aaf8&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./OrderDetails.vue?vue&type=style&index=1&id=5575aaf8&prod&lang=scss&scoped=true")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5575aaf8",
  null
  ,true
)

export default component.exports